<template>
  <b-row class="match-height">
    <b-col md="6" lg="3">
      <div>
        <b-overlay
          :show="showNationalId"
          rounded="sm"
          @shown="onShown"
          @hidden="onHidden"
        >
          <div>
            <b-card
              :img-src="
                require('@/assets/images/requests/fakeNationalId-min.png')
              "
              img-height="270"
              img-alt="Card image cap"
              img-top
              title="بطاقة الرقم القومي"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="col-12"
              >
                عرض
              </b-button>
              <b-row class="mt-1">
                <b-col lg="6">
                  <b-button
                    ref="show"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    :disabled="showNationalId"
                    @click="
                      () => {
                        showNationalId = true;
                        nationalIdStatus = true;
                      }
                    "
                    class="col-12"
                    variant="outline-success"
                    >موافقة
                  </b-button>
                </b-col>
                <b-col lg="6">
                  <b-button
                    ref="show"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    :disabled="showNationalId"
                    class="col-12"
                    @click="
                      () => {
                        showNationalId = true;
                        nationalIdStatus = false;
                      }
                    "
                    variant="outline-danger"
                    >رفض
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <template #overlay>
            <div class="text-center">
              <div v-if="nationalIdStatus">
                <feather-icon
                  icon="CheckCircleIcon"
                  class="text-success"
                  size="50"
                />
                <b-card-text id="cancel-label">
                  <h5 class="mt-1 mb-1 text-success">
                    لقد تم قبول الملف بنجاح
                  </h5>
                </b-card-text>
              </div>
              <div v-else>
                <feather-icon
                  icon="XOctagonIcon"
                  size="50"
                  class="text-danger"
                />
                <b-card-text id="cancel-label">
                  <h5 class="mt-1 mb-1 text-danger">
                    لقد تم رفض الملف
                  </h5></b-card-text
                >
              </div>
              <b-button
                ref="cancel"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-danger"
                size="md"
                aria-describedby="cancel-label"
                @click="showNationalId = false"
              >
                إلغاء
              </b-button>
            </div>
          </template>
        </b-overlay>
      </div>
    </b-col>
    <b-col md="6" lg="3">
      <b-overlay
        :show="taxCard"
        rounded="sm"
        @shown="onShown"
        @hidden="onHidden"
      >
        <div>
          <b-card
            :img-src="require('@/assets/images/requests/91.jpg')"
            img-height="270"
            img-alt="Card image cap"
            img-top
            title="البطاقة الضريبية"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="col-12"
            >
              عرض
            </b-button>
            <b-row class="mt-1">
              <b-col lg="6">
                <b-button
                  ref="show"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :disabled="taxCard"
                  @click="
                    () => {
                      taxCard = true;
                      taxCardStatus = true;
                    }
                  "
                  class="col-12"
                  variant="outline-success"
                  >موافقة
                </b-button>
              </b-col>
              <b-col lg="6">
                <b-button
                  ref="show"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :disabled="taxCard"
                  class="col-12"
                  @click="
                    () => {
                      taxCard = true;
                      taxCardStatus = false;
                    }
                  "
                  variant="outline-danger"
                  >رفض
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <template #overlay>
          <div class="text-center">
            <div v-if="taxCardStatus">
              <feather-icon
                icon="CheckCircleIcon"
                class="text-success"
                size="50"
              />
              <b-card-text id="cancel-label">
                <h5 class="mt-1 mb-1 text-success">لقد تم قبول الملف بنجاح</h5>
              </b-card-text>
            </div>
            <div v-else>
              <feather-icon icon="XOctagonIcon" size="50" class="text-danger" />
              <b-card-text id="cancel-label">
                <h5 class="mt-1 mb-1 text-danger">
                  لقد تم رفض الملف
                </h5></b-card-text
              >
            </div>
            <b-button
              ref="cancel"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              size="md"
              aria-describedby="cancel-label"
              @click="taxCard = false"
            >
              إلغاء
            </b-button>
          </div>
        </template>
      </b-overlay>
    </b-col>
    <b-col md="6" lg="3">
      <b-overlay :show="lease" rounded="sm" @shown="onShown" @hidden="onHidden">
        <div>
          <b-card
            :img-src="require('@/assets/images/requests/lease.png')"
            img-alt="Card image cap"
            img-height="270"
            img-top
            title="عقد الإيجار"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="col-12"
            >
              عرض
            </b-button>
            <b-row class="mt-1">
              <b-col lg="6">
                <b-button
                  ref="show"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :disabled="lease"
                  @click="
                    () => {
                      lease = true;
                      leaseStatus = true;
                    }
                  "
                  class="col-12"
                  variant="outline-success"
                  >موافقة
                </b-button>
              </b-col>
              <b-col lg="6">
                <b-button
                  ref="show"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :disabled="lease"
                  class="col-12"
                  @click="
                    () => {
                      lease = true;
                      leaseStatus = false;
                    }
                  "
                  variant="outline-danger"
                  >رفض
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <template #overlay>
          <div class="text-center">
            <div v-if="leaseStatus">
              <feather-icon
                icon="CheckCircleIcon"
                class="text-success"
                size="50"
              />
              <b-card-text id="cancel-label">
                <h5 class="mt-1 mb-1 text-success">لقد تم قبول الملف بنجاح</h5>
              </b-card-text>
            </div>
            <div v-else>
              <feather-icon icon="XOctagonIcon" size="50" class="text-danger" />
              <b-card-text id="cancel-label">
                <h5 class="mt-1 mb-1 text-danger">
                  لقد تم رفض الملف
                </h5></b-card-text
              >
            </div>
            <b-button
              ref="cancel"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              size="md"
              aria-describedby="cancel-label"
              @click="lease = false"
            >
              إلغاء
            </b-button>
          </div>
        </template>
      </b-overlay>
    </b-col>
    <b-col md="6" lg="3">
      <b-overlay
        :show="commercialRegister"
        rounded="sm"
        @shown="onShown"
        @hidden="onHidden"
      >
        <div>
          <b-card
            :img-src="require('@/assets/images/requests/Commercial_Record.png')"
            img-height="270"
            img-alt="Card image cap"
            img-top
            title="السجل التجاري "
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="col-12"
            >
              عرض
            </b-button>
            <b-row class="mt-1">
              <b-col lg="6">
                <b-button
                  ref="show"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :disabled="commercialRegister"
                  @click="
                    () => {
                      commercialRegister = true;
                      commercialRegisterStatus = true;
                    }
                  "
                  class="col-12"
                  variant="outline-success"
                  >موافقة
                </b-button>
              </b-col>
              <b-col lg="6">
                <b-button
                  ref="show"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :disabled="commercialRegister"
                  class="col-12"
                  @click="
                    () => {
                      commercialRegister = true;
                      commercialRegisterStatus = false;
                    }
                  "
                  variant="outline-danger"
                  >رفض
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <template #overlay>
          <div class="text-center">
            <div v-if="commercialRegisterStatus">
              <feather-icon
                icon="CheckCircleIcon"
                class="text-success"
                size="50"
              />
              <b-card-text id="cancel-label">
                <h5 class="mt-1 mb-1 text-success">لقد تم قبول الملف بنجاح</h5>
              </b-card-text>
            </div>
            <div v-else>
              <feather-icon icon="XOctagonIcon" size="50" class="text-danger" />
              <b-card-text id="cancel-label">
                <h5 class="mt-1 mb-1 text-danger">
                  لقد تم رفض الملف
                </h5></b-card-text
              >
            </div>
            <b-button
              ref="cancel"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              size="md"
              aria-describedby="cancel-label"
              @click="commercialRegister = false"
            >
              إلغاء
            </b-button>
          </div>
        </template>
      </b-overlay>
    </b-col>
    <b-col xs="12">
      <b-card>
        <h3 class="text-center text-primary">بيانات الطلب</h3>
        <hr />
        <b-row>
          <b-col class="mb-1" lg="6">
            <h4>
              <feather-icon
                icon="GitCommitIcon"
                class="mr-1 text-primary"
                size="23"
              ></feather-icon>
              التاجر : مصطفي إسماعيل احمد
            </h4>
          </b-col>
          <b-col class="mb-1" lg="6">
            <h4>
              <feather-icon
                icon="GitCommitIcon"
                class="mr-1 text-primary"
                size="23"
              ></feather-icon>
              مقدم الطلب : محمد احمد السعيد
              <span class="badge badge-primary">مهندس</span>
            </h4>
          </b-col>

          <b-col lg="6">
            <h4>
              <feather-icon
                icon="GitCommitIcon"
                class="mr-1 text-primary"
                size="23"
              ></feather-icon
              >نوع الطلب : شهادة استيراد
            </h4>
          </b-col>
          <b-col lg="6">
            <h4>
              <feather-icon
                icon="GitCommitIcon"
                class="mr-1 text-primary"
                size="23"
              ></feather-icon
              >التاريخ : 8/10/2021
            </h4>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col lg="6">
            <b-form-group label="الحالة">
              <v-select
                v-model="selected"
                dir="rtl"
                label="title"
                :options="option"
              />
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <label for="textarea-default">ملاحظات</label>
            <b-form-textarea
              id="textarea-default"
              placeholder="قم بكتابة الملاحظة هنا"
              rows="3"
            />
          </b-col>
        </b-row>
        <b-button variant="primary" class="mt-5">إرسال</b-button>
      </b-card>
    </b-col>

    <div></div>
  </b-row>
</template>

<script>
import {
  BCard,
  BCardText,
  BButton,
  BRow,
  BCol,
  BFormTextarea,
  BImg,
  BCardBody,
  BCardTitle,
  BOverlay,
  BCardSubTitle,
  BFormGroup,
  BLink,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

import vSelect from "vue-select";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BCardBody,
    BCardTitle,
    BOverlay,
    BCardSubTitle,
    BFormGroup,
    vSelect,
    BRow,
    BFormTextarea,
    BCol,
    BLink,
    BImg,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      option: [{ title: "قيد المراجعة" }, { title: "قبول" }, { title: "رفض" }],
      selected: { title: "قيد المراجعة" },
      showNationalId: false,
      nationalIdStatus: true,
      taxCard: false,
      commercialRegister: false,
      lease: false,
      leaseStatus: true,
      taxCardStatus: true,
      commercialRegisterStatus: true,
    };
  },
  methods: {
    onShown() {
      // Focus the cancel button when the overlay is showing
      this.$refs.cancel.focus();
    },
    onHidden() {
      // Focus the show button when the overlay is removed
      this.$refs.show.focus();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>